export default {
  title: 'Ești sigur?',
  description: 'Următoarele grupuri de modificatori (inclusiv modificatorii lor) vor fi șterse:',
  buttons: {
    yes: 'Da',
    no: 'Nu',
  },
  toasts: {
    modifier_group_got_deleted: 'Grupurile de modificatori au fost șterse',
    failed_to_delete_modifier_group: 'Eroare la ștergerea grupului de modificatori',
  },
};
